import React from 'react';
import {Tag} from 'antd';
import {TagOutlined} from '@/icons';
import PropTypes from 'prop-types';

function AppTagTag({children, ...rest}) {
    return (
        <Tag color="purple" icon={<TagOutlined />} {...rest}>
            {children}
        </Tag>
    );
}

AppTagTag.propTypes = {
    children: PropTypes.node,
};
export default AppTagTag;
